<template>
  <div>
    <h2 class="heading-tertiary">{{ $t('parameters.groupAbility.groupAbilities') }}</h2>

    <div class="roles__table">
      <el-table
        :data="rolesList"
        :row-key="rolesList._id"
        :default-sort = "{prop: 'name', order: 'ascending'}"
        border
        stripe
        header-row-class-name="table__header"
        row-class-name="table__row"
        class="table"
      >
        <el-table-column
          prop="name"
          :label="$t('parameters.groupAbility.list.name')"
          sortable
          min-width="65"
        >
        </el-table-column>

        <el-table-column
          :label="$t('parameters.groupAbility.list.action')"
          min-width="35"
        >
          <template slot-scope="scope">
            <svg v-if="$can('update', 'groupabilities')" class="table__icon table__icon--medium" @click="showEditRole(true); currentRow = scope.row">
              <use href="../assets/sprite.svg#icon-pencil"></use>
            </svg>
            <svg v-if="$can('delete', 'groupabilities')" class="table__icon table__icon--medium" @click="deleteRole(scope.row)">
              <use href="../assets/sprite.svg#icon-cancel"></use>
            </svg>
            <svg v-if="$can('setUsers', 'groupabilities')" class="table__icon table__icon--medium" @click="showSetUsers(true); currentRow = scope.row">
              <use href="../assets/sprite.svg#icon-group"></use>
            </svg>
            <svg v-if="$can('setAcls', 'groupabilities')" class="table__icon table__icon--medium" @click="showSetAcls(); currentRow = scope.row">
              <use href="../assets/sprite.svg#icon-lock"></use>
            </svg>
          </template>
        </el-table-column>
      </el-table>
      <transition name="popup">
        <RoleAdd v-if='getShowAddGroupAbility' @popup:close='getRoles'></RoleAdd>
        <RoleEdit v-if='getShowEditGroupAbility' :role="currentRow" @popup:close='getRoles'></RoleEdit>
        <RoleSetUsers v-if='getShowSetUsersGroupAbility' :role="currentRow" @popup:close='getRoles'></RoleSetUsers>
        <RoleSetAcls v-if='getShowSetAclsGroupAbility' :role="currentRow" @popup:close='getRoles'></RoleSetAcls>
      </transition>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { HTTP_CLIENT } from '@/axios-wrapper'
import { toastMixin } from '@/components/Mixins/Toast'
import { dialogboxMixin } from '@/components/Mixins/Dialogbox'
import RoleEdit from '@/views/popup/RoleEdit.vue'
import RoleAdd from '@/views/popup/RoleAdd.vue'
import RoleSetUsers from '@/views/popup/RoleSetUsers.vue'
import RoleSetAcls from '@/views/popup/RoleSetAcls.vue'

const { mapGetters } = createNamespacedHelpers('groupAbility')

export default {
  data: function () {
    return {
      rolesList: [],
      currentRow: '',
      dialogBoxDelete: {
        title: this.$t('dialog.groupAbility.delete.title'),
        content: this.$t('dialog.groupAbility.delete.content'),
        cancelAction: this.$t('dialog.groupAbility.delete.cancelAction'),
        confirmAction: this.$t('dialog.groupAbility.delete.confirmAction')
      }
    }
  },
  components: {
    RoleEdit,
    RoleAdd,
    RoleSetUsers,
    RoleSetAcls
  },
  mixins: [toastMixin, dialogboxMixin],
  computed: {
    ...mapGetters(['getShowEditGroupAbility', 'getShowAddGroupAbility', 'getShowSetUsersGroupAbility', 'getShowSetAclsGroupAbility'])
  },
  methods: {
    async getRoles () {
      try {
        let { data } = await HTTP_CLIENT.get('groupAbility?sort=name')
        this.rolesList = data
      } catch (error) { console.log(error) }
    },
    showEditRole (scope) {
      this.$store.commit('groupAbility/SHOW_EDIT_GROUPABILITY_POPUP', true)
    },
    showSetUsers (scope) {
      this.$store.commit('groupAbility/SHOW_SETUSERS_GROUPABILITY_POPUP', true)
    },
    showSetAcls () {
      this.$store.commit('groupAbility/SHOW_SETACLS_GROUPABILITY_POPUP', true)
    },
    async deleteRole (row) {
      try {
        const ret = await this.msgbox(this.dialogBoxDelete)
        if (ret === 'confirm') {
          await HTTP_CLIENT.delete(`groupAbility/${row._id}`)
          this.sendSuccessToast(this.$t('feedback-ok.groupAbility.delete', { name: row.name }))
          this.getRoles()
        }
      } catch (error) { console.log(error) }
    }
  },
  mounted () {
    this.getRoles()
  },
  async created () {
    let toolbarIconsID = await this.$store.dispatch('subheader/ADD_ICON_TOOLBAR', [{
      svg: 'icon-plus1',
      fn: () => { return this.$store.commit('groupAbility/SHOW_ADD_GROUPABILITY_POPUP', true) } }])
    this.toolbarIconsID = toolbarIconsID
  },
  destroyed () {
    this.$store.commit('subheader/REMOVE_ICON_TOOLBAR', this.toolbarIconsID)
  }
}
</script>
